// extracted by mini-css-extract-plugin
export default {"bar":"Menu_bar__D5Yji","links":"Menu_links__LfXfO","searchInput":"Menu_searchInput__kyOV3"};